var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hint"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-body"},[[_c('h3',{staticClass:"mar-bot-none"},[_vm._t("title")],2),_c('div',{staticClass:"hint__content"},[_vm._t("default")],2)]],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }